<template>
  <app-toast class='confirm-subscription' :message='message'>
    <div class='toast-body' v-html="$t('toast.confirm-subscription')">
    </div>
  </app-toast>
</template>

<script>
  import appToast from '@/components/app-toast'

  export default {
    name: 'confirm-subscription',

    props: {
      message: Object
    },

    components: {
      'app-toast': appToast
    }
  }
</script>

<style lang='scss' rel='stylesheet/scss'>
</style>
